<template>
    <div class="container">
        <div class="row mt-60">
            <div class="col-sm-12">
                <passwordfield
                v-model="password"
                name="Nieuw wachtwoord"/>
            </div>
            <div class="col-sm-12">
                <div class="form-group">
                    <label>Herhaal wachtwoord </label>
                    <input
                    :class="validateConfirmPassword"
                    v-model="confirmPassword"
                    class="form-control"
                    type="password"
                    name="confirmPassword">
                </div>
            </div>
        </div>
        <div class="row mb-60">
            <div class="col-sm-12">
                <button
                class="btn btn-secondary"
                @click="resetPassword()">Wachtwoord veranderen</button>
            </div>
        </div>
    </div>
</template>

<script>
import AuthorizationService from '@/services/AuthorizationService.js'
import passwordfield from '../Global/Passwordfield'
import TranslationService from '@/services/TranslationService'
import swal from 'sweetalert'

export default {
    components: {
        passwordfield
    },
    data () {
        return {
            password: '',
            confirmPassword: '',
            code: ''
        }
    },
    computed: {
        validateConfirmPassword: function () {
            if (this.confirmPassword.length > 0 && this.password !== this.confirmPassword) {
                return 'is-invalid'
            } else if (this.password.length > 0 && this.password === this.confirmPassword) {
                return 'is-valid'
            }
        }
    },
    created () {
        this.code = this.$route.query.code
    },
    methods: {
        async resetPassword () {
            let data = {
                Code: this.code,
                Password: this.password,
                ConfirmPassword: this.confirmPassword
            }
            let result = await AuthorizationService.resetPassword(data)
            this.password = ''
            this.confirmPassword = ''
            let currentPage = this
            switch (result) {
            case 'PASSWORD_MISMATCH':
                swal('', TranslationService.get('PASSWORD_MISMATCH'), 'warning')
                break
            case 'WEAK_PASSWORD':
                swal('', TranslationService.get('WEAK_PASSWORD'), 'warning')
                break
            case 'FAILURE':
                swal('', TranslationService.get('PASSWORD_RESET_FAILURE'), 'warning')
                break
            case 'SUCCESS':
                swal('', TranslationService.get('PASSWORD_RESET_SUCCESS'), 'success')
                    .then(async function () {
                        currentPage.$router.push({name: 'login'})
                    })
                break
            default:
                swal('', TranslationService.get('SOMETHING_WENT_WRONG'), 'warning')
                break
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Authentication/ResetPassword.vue